export const hasTermWithSlug = (terms, slug) =>
  (terms || []).map(t => t.slug).includes(slug);

/**
 * Returns a list of strings that match the strings in a whitelist/
 * list of allowed strings.
 *
 * Assumption: all whitelist terms will be in a hyphenated slug format
 * so each we should check against the tag slug
 *
 * @export
 * @param {Array} tags list of tags
 * @param {Array} whitelist strings to match
 * @return {Array} subset of the initial terms that match the whitelist
 */
export const filterTermsBySlug = (terms, whitelist) =>
  (terms || []).filter(t => (whitelist || []).includes(t.slug));

export function hasSomeTargetedTerms(terms, targetedTerms) {
  return targetedTerms.some(term => hasTermWithSlug(terms, term));
}

export function hasAllTargetedTerms(terms, targetedTerms) {
  return targetedTerms.every(term => hasTermWithSlug(terms, term));
}
